import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import DataTable from "@client.components/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { makeProfile } from "@client.pages/Login/reducer";
import { getMeetingsAsync, makeMeetings } from "../reducer";
import { getMeetingsColumns } from "./consts";
import { makeFilter } from "@client.components/TopChartFilters/reducer";
import { makeSelectedInsight, clearSelectedInsight } from "@client.pages/Dashboard/reducer";

const MeetingsDataTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const filter = useSelector(makeFilter);
  const profile = useSelector(makeProfile);
  const meetings = useSelector(makeMeetings);
  const selectedInsight = useSelector(makeSelectedInsight);

  // Clear selected insight when component unmounts
  useEffect(() => {
    return () => {
      dispatch(clearSelectedInsight());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getMeetingsAsync({
        filter,
        isCostIndexPresentation: profile.isCostIndexPresentation,
        insightId: selectedInsight?.id || null,
      })
    );
  }, [dispatch, filter, profile, selectedInsight?.id]);

  return (
    <DataTable
      columns={getMeetingsColumns(
        t,
        meetings.data,
        profile.isCostIndexPresentation,
        selectedInsight
      )}
      data={meetings.data}
      isLoading={meetings.load}
    />
  );
};

export default MeetingsDataTable;
